module.exports = __webpack_public_path__ + "operace-usnich-boltcu_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-usnich-boltcu_1_before.jpg
// module id = 1212
// module chunks = 0